import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IPRFCreateRequestBody, IPRFCreateResponse } from "@/api_framework/api_modals/Inventory";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

export const usePRFCreateAPI = () => {
  const configuration = useConfiguration();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { captureError } = useAPIUtils();

  const execute = useCallback(async (payload: IPRFCreateRequestBody): Promise<IPRFCreateResponse | null> => {
    try {
      setIsSubmitting(true);
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const baseURL = INVENTORY_MODULE.PRODUCT_REQUIREMENT_FORM_CREATE.baseURL;

      const response = await axios
        .post(baseURL, payload, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IPRFCreateResponse>) => {
          if (res.data.status) {
            toast.success(res.data.message || "Product requirement form submitted successfully.");
          } else {
            toast.error(res.data.message || "Failed to submit product requirement form.");
          }
          return res.data;
        })
        .catch((e: AxiosError) => {
          captureError(e);
          return null;
        });

      return response;
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      return null;
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return { execute, isSubmitting };
};
